<template lang="pug">
include ../pug/svg
section#organisation
	nav.navbar.sticky
		div
			ul
				li(v-if="hasFeature('organisation','settings')")
					AppLink(:to="{name:'ManageOrganisationSettings'}") Settings
				li(v-if="hasFeature('organisation','features')")
					AppLink(:to="{name:'ManageOrganisationFeatures'}") Features
				//-li(v-if="hasFeature('organisation','billing')")
					AppLink(:to="{name:'ManageOrganisationBilling'}") Billing
			button.but.pri.spinner(:class="{spin:saving}" type="button" :disabled="saving||!canSave" @click="saveOrganisation") Save
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
			button.but.pri.spinner(:class="{spin:resetting}" type="button" :disabled="resetting||saving||!canCancel" @click="cancelOrganisation") Cancel
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
			button.but.pri.spinner(v-if="isFeatures" :class="{spin:resetting}" type="button" :disabled="saving||resetting||!canReset" @click="resetFeatures") Defaults
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
			
	ModalConfirm(:active="leaveTo" :useDrag="true" @cancel="leaveTo=null" @confirm="cancelOrganisation")
	router-view(v-slot="{Component}")
		transition(name="section" mode="out-in" enter-active-class="hide" leave-active-class="hide" appear)
			component(:is="Component" :cancelled="cancelled" @storeUpdated="storeUpdated($event)")
</template>

<script>
import ModalConfirm from '../components/ModalConfirm';
import OrganisationService from '../services/OrganisationService';

export default {
	name: 'ManageAccount',
	components: {
		ModalConfirm,
	},
	data() {
		return {
			updated: {
				features: null,
				settings: null,
				//billing: null,
			},
			canSave: false,
			canCancel: false,
			canReset: true,
			cancelled: false,
			saving: false,
			resetting: false,
			leaveTo: null,
		}
	},
	beforeRouteLeave (to, from, next) {
		// unsaved changes
		if (this.canSave && !this.leaveTo) {
			this.leaveTo = to;
			this.$store.dispatch('gui/setTintState', true);
			next(false);
			
		} else {
			next();			
		}
	},
	computed: {
		isFeatures() {
			return (this.$route.name === 'ManageOrganisationFeatures');
		},
		usrSeniority() {
			return this.$store.getters['auth/getUserSeniority'];
		},
	},
	methods: {
		hasFeature(feature, subfeature) {
			return this.$store.getters['gui/hasFeature'](feature, subfeature);
		},
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		storeUpdated({screen, valid}) {
			// log screen updated for efficient save
			this.updated[screen] = valid;
			let validSet = null;
			
			for(let screen in this.updated) {
				if (this.updated[screen] === false) {
					validSet = false;
					
				} else if (this.updated[screen] === true && validSet !== false) {
					validSet = true;
				}
			}
			
			// enable save button
			this.canSave = validSet ? true : false;
			this.canCancel = true;
		},
		resetFeatures() {
			this.canSave = true;
			this.canCancel = true;
			this.canReset = false;
			
			// reset default features from gui
			this.$store.dispatch('gui/resetFeatures');
			
			this.storeUpdated({
				screen: 'features',
				valid: true,
			});
		},
		async cancelOrganisation() {
			this.cancelled = true;
			this.canSave = false;
			this.canCancel = false;
			this.canReset = false;
			this.resetting = true;
			
			const delay = this.$store.getters['gui/delay'];			
			
			// reset organisation from db
			await this.$store.dispatch('gui/initOrganisation');
			
			await delay;
			
			// disable save until changes
			this.resetFlags();
		},
		async saveOrganisation() {
			try {
				this.saving = true;
				this.canSave = false;
				this.canCancel = false;
				this.canReset = false;
				
				const delay = this.$store.getters['gui/delay'];
				
console.log('this.updated:', this.updated);		
				if (this.updated.features || this.updated.settings) {
console.log('featureData:A', this.$store.state.gui.feature);
					// save organisation to db
					const organisation = this.$store.state.gui.organisation;
					await OrganisationService.updateBySubdomain({
						name: organisation.name,
						websiteUrl: organisation.websiteUrl,
						emailGeneral: organisation.emailGeneral,
						emailSales: organisation.emailSales,
						emailSupport: organisation.emailSupport,
						phoneGeneral: organisation.phoneGeneral,
						phoneSales: organisation.phoneSales,
						phoneSupport: organisation.phoneSupport,
						userLimit: organisation.userLimit,
						maxBytesImg: organisation.maxBytesImg,
						maxBytesMp3: organisation.maxBytesMp3,
						maxBytesMp4: organisation.maxBytesMp4,						
						assignmentIndividual: organisation.assignmentIndividual,
						assignmentAuto: organisation.assignmentAuto,
						notificationAnonymous: organisation.notificationAnonymous,
						featureData: this.$store.state.gui.feature,
					});
					
				} else {
console.log('featureData:B', this.$store.state.gui.feature);
				}
				
				await delay;
				
				this.resetFlags();
				
			} catch(err) {
				// handle error
				console.log('saveOrganisation()>err:', err.response.status, err.response.data.message);
//				actions.setFieldError('name', err.response.data.message);
			}
		},
		resetFlags() {
			// reset
			this.updated.features = null;
			this.updated.settings = null;
			this.canSave = false;
			this.canCancel = false;
			this.canReset = true;
			this.saving = false;
			this.resetting = false;
		},
	},
}
</script>

<style lang="scss">
</style>
